/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 16 2024
 **/

type UserGeneric<T> = T & { username: string; name: string };

export const getFilteredUserList = <T>(userList: UserGeneric<T>[], predicate: (user: UserGeneric<T>) => void) => {
	return userList
		.map((obj) => ({ ...obj, username: obj.username.toLowerCase(), name: obj.name.toLowerCase() }))
		.filter(predicate);
};

export const getFilteredUserListByValue = <T>(userList: UserGeneric<T>[], value: string) => {
	const lowerCaseValue = value.toLowerCase();
	const predicate = (user: UserGeneric<T>) => {
		return user.name.includes(lowerCaseValue) || user.username.includes(lowerCaseValue);
	};
	return getFilteredUserList(userList, predicate);
};
